// @ts-ignore
import TasksCustomFieldsLookup from "../../model2/project/inheritance/task-custom-fields"
import ItemsCollection from "../../model2/item/items-collection"
import ItemsCollectionV2 from "../../model2/item2/items-collection"
import ItemModel from "../../model2/item/item-model"
import GanttItemsCollection from "../../gd-modules/gantt-chart/model/gantt-collection"
import GanttItem from "../../gd-modules/gantt-chart/model/gantt-item-new"
import SessionCustomField from "../../model2/custom-field/session-custom-field"
import getProjectTaskListCustomFields from "./custom-fields/custom-fields-manager"
import getTaskViewCustomFields from "./custom-fields/task-view-custom-fields"
import {CustomFieldScope} from "../../model2/custom-field/@const"

// const debug = "CustomFieldsManager"
const debug = false

export default class CustomFieldsManager {

    // I guess used in task view to determine which CF to show for this task
    static getTaskViewCustomFields(taskTypeId?:ID, projectsIds?: ID[]):SessionCustomField[] {
        return getTaskViewCustomFields(taskTypeId, projectsIds)
    }

    // Used in Table / List / Etc views under project
    static getProjectTaskListCustomFields(taskTypeIds?:ID[], projectId?:ID, scope?:CustomFieldScope[]):SessionCustomField[] {
        return getProjectTaskListCustomFields(taskTypeIds, projectId, scope)
    }

    static getCustomViewCustomFields(data:{listItems?: ItemsCollection | ItemsCollectionV2 | GanttItemsCollection, taskItems?:any} = {listItems:undefined, taskItems:undefined}) {
        let customFieldIds  : ID[]  = []
        let customFields    : any[] = []
        let taskTypeIds     : ID[]  = []

        // data.listItem may be array or collection

        // @ts-ignore
        _.map(data.listItems?.models, (listItem:ItemModel | GanttItem)=>{
            if (listItem.isTask && listItem.item.customFieldsData) {
                customFieldIds = _.concat(customFieldIds, _.keys(listItem.item.customFieldsData));
                taskTypeIds.push(listItem.task.taskTypeId)
            }
        })

        _.map(data.taskItems, (item:any) => {
            if (item.customFieldsData) {
                customFieldIds = _.concat(customFieldIds, _.keys(item.customFieldsData));
                taskTypeIds.push(item.taskTypeId)
            }
        });

        const allTaskTypeIds = _.uniq(taskTypeIds)

        // add custom fields from all task types
        _.map(allTaskTypeIds, taskTypeId => {
            const taskType = gd.session.taskTypes.get(taskTypeId)
            if (taskType) customFieldIds = _.concat(customFieldIds, taskType.customFields)
        })

        customFieldIds = _.uniq(customFieldIds);

        // we DO NOT check access here as with custom views it's impossible here... check should be done in CELL view separately

        const isManager = gd.ac.check.company.isManager(gd.companyId);

        // create CF objects array
        customFieldIds.map(customFieldId => {
            const customField = gd.session.customFields.get(customFieldId)!
            if (customField && (isManager || customField.access === gd.const.customFields.access.EVERYONE)) customFields.push(customField);
        });

        return customFields;
    }

    // navernoe dlya project settings ?
    static getProjectCustomFields(projectId:ID, exportOptions: boolean = false) {
        const tasksCustomFieldsLookup = new TasksCustomFieldsLookup(projectId);
        let res = tasksCustomFieldsLookup.getCustomFields();

        /*const sessionProject = gd.session.projects.get(projectId);

        let res = [];

        //collect parent projects custom fields
        const parentProjects = gd.tree.findProjectParents(gd.tree.getProject(projectId)).map(p=>p.id);
        parentProjects && parentProjects.map(pId=>{
            const project = gd.session.projects.get(pId);
            if (project && project.customFields) {
                console.log("CustomFieldsManager getProjectCustomFields", project.id, project.customFields);

                res = res.concat(project.customFields.map(id=>{
                    let cf = gd.session.customFields.get(id).clone();
                    cf.setInherited(true);
                    return cf;
                }));
            }

        });

        res = _.uniqBy(res, cf=>cf.id); // just to clear duplicates (there were some caused by dnd issue)

        const alreadyAddedCustomFields = _.map(res, cf=>cf.id);
        const ownCustomFields = _(sessionProject.customFields)
            .filter(id=>!alreadyAddedCustomFields.includes(id)) // filter inherited custom fields
            .uniq() // just to clear duplicates if any
            .map(id=>gd.session.customFields.get(id).clone())
            .value();
        res = res.concat(ownCustomFields);*/

        const isManager = gd.ac.check.company.isManager(gd.companyId);
        res = isManager ? res : _.filter(res, cf=>cf.access === gd.const.customFields.access.EVERYONE)

        if (exportOptions) {
            return _.map(res, (cf)=>{

                return {
                    type    : cf.type,
                    value   : cf.id,
                    label   : cf.name,
                    access  : cf.access,
                }
            })
        }

        return res;
    }

    // a hren ego znaet dlya chego ono...
    static getAvailableCustomFields(projectId: ID | null, taskTypeId: ID | null, scope: any, exportOptions = true):any[] {

        if (!projectId && !taskTypeId) {
            console.warn("#jdh873 CustomFieldsManager getExistingCustomFields: projectId and/or taskTypeId required;");
            return []
        }


        let res = [];

        const companyCustomFields = gd.session.customFields.filterByCompany(gd.companyId);

        const taskType = gd.session.taskTypes.get(taskTypeId!);
        const taskTypeCustomFields = taskType ? taskType.customFields : [];

        const project = gd.session.projects.get(projectId);
        const projectCustomFields = project ? CustomFieldsManager.getProjectCustomFields(project.id).map((cf:any)=>cf.id) : [];

        const restrictedCustomFieldsIds = _.union(taskTypeCustomFields, projectCustomFields);
        const isManager = gd.ac.check.company.isManager(gd.companyId);

        if (exportOptions) {
            res = _.chain(companyCustomFields.exportOptions())
                .filter(cf=>(isManager || cf.access === gd.const.customFields.access.EVERYONE) &&
                    (!scope || _.intersection(scope, cf.scope).length > 0) &&
                    !restrictedCustomFieldsIds.includes(cf.value))
                .orderBy(cf=>cf.sortPosition, 'asc')
                .value();
        } else {
            res = _.chain(companyCustomFields.models)
                .filter(cf=>(isManager || cf.access === gd.const.customFields.access.EVERYONE) &&
                    (!scope || _.intersection(scope, cf.params.scope).length > 0) &&
                    !restrictedCustomFieldsIds.includes(cf.id))
                .orderBy(cf=>cf.sortPosition, 'asc')
                .value();
        }

        return res;
    }

    //collect all custom fields (IDs) for passed task types and projects
    static getTaskTypesProjectsCustomFields(taskTypeIds:ID[], projectIds:ID[]) {
        let customFieldsIds : any = [];

        _.map(projectIds, pId=>{
            customFieldsIds = customFieldsIds.concat(new TasksCustomFieldsLookup(pId).getAll());
        })

        /*// find all parent and child projects to create ultimates project Ids array
        let allProjectsIds = [];
        _.map(projectIds, pId=>{
            allProjectsIds.push(pId);
            allProjectsIds = _.concat(allProjectsIds, gd.tree.findProjectParents(gd.tree.getProject(pId)).map(p=>p.id));
            allProjectsIds = _.concat(allProjectsIds, gd.tree.findProjectChildren(pId).map(p=>p.id));
        })
        allProjectsIds = _.uniq(allProjectsIds);

        // get custom fields from all projects
        allProjectsIds.map(projectId=>{
            const project = gd.session.projects.get(projectId);
            if (project && project.customFields) customFieldsIds = _.concat(customFieldsIds, project.customFields);
        });*/

        // add custom fields from all task types
        _.map(taskTypeIds, taskTypeId => {
            const taskType = gd.session.taskTypes.get(taskTypeId);
            if (taskType) customFieldsIds = _.concat(customFieldsIds, taskType.customFields);
        });

        // find unique only
        customFieldsIds = _.uniq(customFieldsIds);

        return customFieldsIds;
    }

    // return amepresand models of cusotm fields
    static getOrganizationCustomFields(organizationId:ID, scope?:any /*array of scopes (gd.const.customFields.scope)*/):any[] {
        const customFields = gd.session.customFields.filterByCompany(organizationId);
        const isManager = gd.ac.check.company.isManager(gd.companyId);

        let res : any[];
        if (scope) {
            res = _.filter(customFields.models, cf=>(isManager || cf.access === gd.const.customFields.access.EVERYONE) && _.intersection(cf.params.scope, scope).length > 0);
        } else {
            res = _.filter(customFields.models, cf=>isManager || cf.access === gd.const.customFields.access.EVERYONE);
        }

        // apply CF manaual sorting
        res = _.sortBy(res, 'sortPosition')

        return res;
    }

    //project specific custom fields (for project itself, not for project tasks)
    /*static getProjectsListItemsCustomFieldsIds(projectListItems) {
        let customFieldsIds = new Set();
        _.map(projectListItems, listItem => {
            if (listItem.item.customFieldsData) {
                const cfIds = _.keys(listItem.item.customFieldsData);
                customFieldsIds = new Set([...customFieldsIds, ...cfIds])
            }
        });

        return [...customFieldsIds];
    }*/

    /*static getProjectsListItemsCustomFields(projectListItems) {
        const customFields = new Set();

        const customFieldsIds = CustomFieldsManager.getProjectsListItemsCustomFieldsIds(projectListItems);
        _.map(customFieldsIds, customFieldId => {
            const customField = gd.session.customFields.get(customFieldId)!
            if (customField) customFields.add(customField);
        });

        return [...customFields];
    }*/
}
